// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"e493f801","294":"e74a6bdd","337":"b8343de4","499":"6311c92a","810":"656e7807","827":"4e6c6474","852":"f169b1af","872":"df1b3d43","967":"84a3274a"}[chunkId] + ".chunk.css";
};